<div class="container-fluid">
	<h2>{{'noc_config.title' | translate}}</h2>

	<!-- Action Buttons -->
	<div class="button-container d-flex justify-content-between mb-3">
		<div>
			<button *ngIf="hasWriteAccess" type="button" (click)="addConfiguration()" class="btn btn-primary mr-2">
				{{'noc_config.add_new' | translate}}
				<i class="fa fa-plus ml-1"></i>
			</button>
			<button *ngIf="hasWriteAccess" type="button" (click)="manageRecipients()" class="btn btn-secondary">
				{{'noc_config.recipients' | translate}}
				<i class="fa fa-envelope ml-1"></i>
			</button>
		</div>
	</div>

	<!-- Tabs -->
	<ul class="nav nav-tabs mb-3">
		<li class="nav-item">
			<a
				class="nav-link"
				[class.active]="activeTab === 'unused'"
				(click)="switchTab('unused')"
				style="cursor: pointer;">
				{{'noc_config.not_used_code' | translate}}
			</a>
		</li>
		<li class="nav-item">
			<a
				class="nav-link"
				[class.active]="activeTab === 'used'"
				(click)="switchTab('used')"
				style="cursor: pointer;">
				{{'noc_config.used_code' | translate}}
			</a>
		</li>
	</ul>

	<!-- Table -->
	<div class="mt-2 mb-2">
		<sct-custom-table
			*ngIf="tableData.length > 0"
			[data]="tableData"
			[columnsConfig]="columnConfig"
			[config]="tableConfig">
		</sct-custom-table>

		<div *ngIf="tableData.length === 0" class="alert alert-info">
			{{'g.no_data_available_for_the_selected_period' | translate}}
		</div>
	</div>
</div>

<!-- Delete Confirmation Modal -->
<app-modal 
	#deleteNocConfigModal 
	[title]="'g.confirm_action' | translate"
	[message]="'g.confirm_delete_message' | translate">
</app-modal>
